/**
 * Created by AlexanderC on 5/25/15.
 */

/*eslint no-undefined: 0*/

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Request = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Request received by the lambda context
 */
let Request = exports.Request = function () {
  /**
   * @param {*} data
   */
  function Request() {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Request);

    this._data = !Array.isArray(data) ? _qs2.default.parse(data) : data;

    this._registerDataAsParams();
  }

  /**
   * @private
   */


  _createClass(Request, [{
    key: '_registerDataAsParams',
    value: function _registerDataAsParams() {
      for (let key in this._data) {
        if (!this._data.hasOwnProperty(key)) {
          continue;
        }

        Object.defineProperty(this, key, {
          value: this._data[key],
          writable: false,
          configurable: false,
          enumerable: true
        });
      }

      // Avoid _data key listing on Object.keys(request)
      Object.defineProperty(this, '_data', {
        configurable: false
      });
    }

    /**
     * @returns {*}
     */

  }, {
    key: 'getParam',


    /**
     * @param {String} name
     * @param {String|Object|null} defaultValue
     *
     * @returns {String|Object|null}
     */
    value: function getParam(name) {
      let defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      return this._data.hasOwnProperty(name) ? this._data[name] : defaultValue;
    }
  }, {
    key: 'data',
    get: function get() {
      return this._data;
    }
  }]);

  return Request;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/AWS/Lambda/Request.js
// module id = 365
// module chunks = 0